
import * as __star__ from '@ckeditor/ckeditor5-minimap/dist/index.js';

const {

Minimap,
_MinimapIframeView,
_MinimapPositionTrackerView,
_MinimapView,
_cloneMinimapEditingViewDomRoot,
_getMinimapClientHeight,
_getMinimapDomElementRect,
_getMinimapPageStyles,
_getMinimapScrollable,
__esModule
} = __star__;

export {
Minimap,
_MinimapIframeView,
_MinimapPositionTrackerView,
_MinimapView,
_cloneMinimapEditingViewDomRoot,
_getMinimapClientHeight,
_getMinimapDomElementRect,
_getMinimapPageStyles,
_getMinimapScrollable,
__esModule
};

